import {
  Category2,
  Shop,
  Simcard1,
  ProfileCircle,
  Bill,
  Messages,
  MessageQuestion,
  TicketStar,
} from 'iconsax-react';
import * as URLS from '@src/constants/URLS.const';

export const menuItems = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    url: URLS.DASHBOARD_URL,
    icon: <Category2 variant='Bulk' />,
  },
  {
    key: URLS.ROUTE_STORE_BASE_URL,
    label: 'Store',
    url: URLS.ROUTE_STORE_FULL_URL,
    icon: <Shop variant='Bulk' />,
  },
  {
    key: URLS.ROUTE_MY_ESIMS_BASE_URL,
    label: 'My eSIMs',
    url: URLS.ROUTE_MY_ESIMS_FULL_URL,
    icon: <Simcard1 variant='Bulk' />,
  },
];

export const extraMenuItems = [
  {
    key: URLS.PROFILE_BASE_URL,
    label: 'Profile',
    url: URLS.ROUTE_PROFILE_FULL_URL,
    icon: <ProfileCircle variant='Bulk' />,
  },
  {
    key: URLS.ROUTE_BILLING_BASE_URL,
    label: 'Billing',
    url: URLS.ROUTE_BILLING_FULL_URL,
    icon: <Bill variant='Bulk' />,
  },
  {
    key: URLS.ROUTE_HELP_AND_SUPPORT_BASE_URL,
    label: 'Help and support',
    url: URLS.ROUTE_HELP_AND_SUPPORT_FULL_URL,
    icon: <Messages variant='Bulk' />,
  },

  {
    key: URLS.ROUTE_FAQ_BASE_URL,
    label: 'FAQ',
    url: URLS.ROUTE_FAQ_FULL_URL,
    icon: <MessageQuestion variant='Bulk' />,
  },
];

export const affiliateMenuItems = [
  {
    key: URLS.ROUTE_AFFILIATE_BASE_URL,
    label: 'Affiliate',
    url: URLS.ROUTE_AFFILIATE_FULL_URL,
    icon: <TicketStar variant='Bulk' />,
  },
];

export const sidebarMenuItems = [...menuItems, ...extraMenuItems];
export const sidebarWithAffiliateMenuItems = [
  ...menuItems,
  ...extraMenuItems,
  ...affiliateMenuItems,
];
